import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CustomCalendar from "../../components/CustomCalendar/CustomCalendar";
import EyRnButton from "../../components/EyRnButton/EyRnButton";
import AppDataContext from "../../context/AppDataContext";
import Library from "../Library/Library";
import Scan from "../Scan/Scan";
import Strategy from "../Strategy/Strategy";
import "./Search.scss";
const initialCardData = [
  "Show my risks",

  "Show my controls",

  "Show mitigation plans",

  "Show vendors",

  "Show regulations",

  "Add new supplier",
];
const allLocations = [
  "All locations",
  "Africa",
  "America",
  "Asia",
  "Europe",
  "More",
];
const compCardData = ["Map", "Risk Universe", "Grid"];
export default function Search() {
  const navigate = useNavigate();
  const [cardData, setCardData] = useState(initialCardData);
  const [view, setView] = useState("cards");
  const [inputValue, setInputValue] = useState("");
  const { setHeaderShow } = useContext(AppDataContext);

  // const [cardData, setCardData] = useState(compCardData);
  //
  useEffect(() => {
    setHeaderShow(false);
  }, []);

  const handleTheCard = (value: string) => {
    if (value === "Show my risks") {
      setInputValue("Show my risk for |");
      setCardData(allLocations);
    } else if (value === "All locations") {
      setView("calender");
      setInputValue("Show my risk for All locations during |");
    } else if (value === "Map") {
   
     setInputValue("Map")
    } else if (value === "Risk Universe") {

    setInputValue("strategy")
    } else if (value === "Grid") {
 
    setInputValue("library")
    }
  };
  const calendarHandler = (e: any) => {
    if (e) {
      setView("cards");
      setInputValue("Show my risk for All locations during 2024 as a |");
      setCardData(compCardData);
    }
  };
  const reset = (value:string) => {
    if(value==="Show my risk for |"){
      setCardData(initialCardData);
      setView("cards");
      setInputValue("");
  }else if(value==="Show my risk for All locations during |"){
    setCardData(allLocations);
      setView("cards");
      setInputValue("Show my risk for |");
  }else{
    setCardData(initialCardData);
    setView("cards");
    setInputValue("");
  }

   
  };

  

  return (
    <div >
   {inputValue!=="Map" && inputValue!=="strategy"&& inputValue!=="library"&&<div className="container" style={{overflow:"hidden"}}>
      <EyRnButton />
      <div>
        <h3 className="content-header">How can I help you today?</h3>
      </div>
      <div className="container-body">
        <div style={{position:'relative'}}>
          <div className="icon-mic " style={{position:'absolute',left:'15px'}}></div>
          {inputValue==="Show my risk for |" || inputValue==="Show my risk for All locations during |" ||
           inputValue==="Show my risk for All locations during 2024 as a |"    ? (
            <div style={{position:'relative'}}><div style={{position:'absolute',left:'-28px',    color: '#747480'}} onClick={(e)=>reset(inputValue)} className="icon-x-circle"></div>
             <div className="verticalLine"></div>
            <div style={{position:'absolute',left:'15px'}}className="icon-arrow-right"></div></div>
          ) : (
            <span className="icon-arrow-right"></span>
          )}
          <input
            value={inputValue}
            className="input-box"
            onChange={(e)=>setInputValue(e.target.value)}
            placeholder="What can I help you with ?"
          />
        </div>
        {view === "cards" && (
          <div className="row-box ">
            {cardData.map((value,index) => {
              return (
                <div key={index}
                  onClick={() => {
                    handleTheCard(value);
                  }}
                  className="container-box"
                >
                  <div className="icon-zap "></div>
                  <div>{value}</div>
                </div>
              );
            })}
          </div>
        )}
        {view === "calender" && <CustomCalendar onChange={calendarHandler} />}
        
      </div>
    </div>}
    {inputValue === "Map" && <Scan/>}
    {inputValue === "strategy" && <Strategy/>}
    {inputValue === "library" && <Library/>}
    </div>
  );
}
